// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

export const ComponentTitleAmpersandFragmentDoc = `
    fragment componentTitleAmpersand on ComponentTitleAmpersand {
  __typename
  null
}
    `;